
  import { defineComponent, PropType } from 'vue';

  import Constants from '@/common/constants';
  import { downloadPDF } from '@/common/utils/fileExport';

  import API from '../../../api/statisticsPortal';
  import { TStatisticsPortalFilter } from '../../../types/statistics/statistics-portal';
  import { moveStatisticsTabsToTopLevel, replaceFiltersWithText } from '../../../utils/statistics';
  import StatisticsExportButtons from '../StatisticsExportButtons.vue';

  export default defineComponent({
    name: 'StatisticsPortalExportButtons',
    components: { StatisticsExportButtons },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
    data(): {
      isExportProgress: boolean;
      exportPermission: number;
    } {
      return {
        isExportProgress: false,
        exportPermission: Constants.Permissions.AuditPortalStatisticExport,
      };
    },
    methods: {
      async exportPdf() {
        this.isExportProgress = true;
        await downloadPDF({
          clonedElementClassName: 'statistics-portal__export-pdf',
          fileName: 'Статистика посещений. Административная часть',
          clonedNodeFormatter: (cloned: HTMLElement) => {
            replaceFiltersWithText(cloned);
            moveStatisticsTabsToTopLevel(cloned);
          },
          opt: {
            margin: { top: 15, right: 0, bottom: 20, left: 0 },
          },
        });
        this.isExportProgress = false;
      },
      async exportExcel() {
        this.isExportProgress = true;

        try {
          await API.exportExcel(this.filter);
        } finally {
          this.isExportProgress = false;
        }
      },
    },
  });
